import {
    DONATE_ADDNEW_DONATION_SESSION,
    DONATE_UPDATE_DONATION_SESSION,
    DONATE_DELETE_DONATION_SESSION,
    DONATE_GET_ALL_DONATION_SESSION,
    DONATION_GET_ALL_DONETED_USERS,
    DONATION_DELETE_DONATED_USER
} from "../actions/donation";

import {
    API_BASE_URL,
    DONATE_ADDNEW_DONATION_SESSION_URL,
    DONATE_UPDATE_DONATION_SESSION_URL,
    DONATE_DELETE_DONATION_SESSION_URL,
    DONATE_GET_ALL_DONATION_SESSION_URL,
    DONATION_GET_ALL_DONETED_USERS_URL,
    DONATION_DELETE_DONATED_USER_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [DONATION_GET_ALL_DONETED_USERS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DONATION_GET_ALL_DONETED_USERS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [DONATE_ADDNEW_DONATION_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DONATE_ADDNEW_DONATION_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [DONATE_UPDATE_DONATION_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DONATE_UPDATE_DONATION_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [DONATE_DELETE_DONATION_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DONATE_DELETE_DONATION_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [DONATE_GET_ALL_DONATION_SESSION]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DONATE_GET_ALL_DONATION_SESSION_URL,
            method: "GET",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [DONATION_DELETE_DONATED_USER]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + DONATION_DELETE_DONATED_USER_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};